import { DriverCommunication, DriverCommunicationDTO } from '../api-types';
import { fetchAction } from '../../actions';
import CoreAPIService from '../../../utils/core-api';

export const name: string = 'driverCommunication';

const BASE_URL = '/core/driver-communications';

// Action Types
export const types = {
    GET_DRIVER_COMMUNICATIONS: `${name}/GET_DRIVER_COMMUNICATIONS`,
    GET_DRIVER_COMMUNICATION: `${name}/GET_DRIVER_COMMUNICATION`,
    CREATE_DRIVER_COMMUNICATION: `${name}/CREATE_DRIVER_COMMUNICATION`,
    UPDATE_DRIVER_COMMUNICATION: `${name}/UPDATE_DRIVER_COMMUNICATION`,
    DELETE_DRIVER_COMMUNICATION: `${name}/DELETE_DRIVER_COMMUNICATION`,
};

interface DriverCommunicationState {
    communications: DriverCommunication[];
}

// Initial State
const initialState: DriverCommunicationState = {
    communications: [],
};

const upsert = (communications: DriverCommunication[], communication: DriverCommunication): DriverCommunication[] =>
    communications.some((c) => c.id === communication.id)
        ? communications.map((c) => (c.id === communication.id ? communication : c))
        : [...communications, communication];

// Reducer
const reducer = (state = initialState, action: any): DriverCommunicationState => {
    const { payload, parameters } = action;
    switch (action.type) {
        case types.GET_DRIVER_COMMUNICATIONS:
            return { ...state, communications: Array.isArray(payload) ? payload : [] };
        case types.GET_DRIVER_COMMUNICATION:
        case types.CREATE_DRIVER_COMMUNICATION:
        case types.UPDATE_DRIVER_COMMUNICATION:
            return payload?.id ? { ...state, communications: upsert(state.communications, payload) } : state;
        case types.DELETE_DRIVER_COMMUNICATION:
            return {
                ...state,
                communications: state.communications.filter((c) => String(c.id) !== String(parameters?.id)),
            };
        default:
            return state;
    }
};
export default reducer;

// Actions
export const actions = {
    getDriverCommunications: () => fetchAction(CoreAPIService.get(BASE_URL), types.GET_DRIVER_COMMUNICATIONS, {}),
    getDriverCommunication: (id: string) =>
        fetchAction(CoreAPIService.get(`${BASE_URL}/${id}`), types.GET_DRIVER_COMMUNICATION, { id }),
    createDriverCommunication: (payload: DriverCommunicationDTO, success?: () => void) =>
        fetchAction(CoreAPIService.post(BASE_URL, payload), types.CREATE_DRIVER_COMMUNICATION, {}, { success }),
    updateDriverCommunication: (id: string, payload: DriverCommunicationDTO, success?: () => void) =>
        fetchAction(
            CoreAPIService.put(`${BASE_URL}/${id}`, payload),
            types.UPDATE_DRIVER_COMMUNICATION,
            { id },
            { success },
        ),
    deleteDriverCommunication: (id: string, success?: () => void) =>
        fetchAction(CoreAPIService.delete(`${BASE_URL}/${id}`), types.DELETE_DRIVER_COMMUNICATION, { id }, { success }),
};

// Selectors
const localState = (state: any): DriverCommunicationState => state[name] || initialState;
export const selectors = {
    communications: (state): DriverCommunication[] => localState(state).communications,
    communicationById: (state, id: string): DriverCommunication | undefined =>
        localState(state).communications.find((c) => String(c.id) === String(id)),
};
